import { createGetPropGetter } from '@/store/utils';

export default {
  integrationsByCategory: createGetPropGetter('integrationsByCategory', []),
  integrationTestingLoading: createGetPropGetter('integrationTestingLoading', false),
  integrationDetailsToEdit: createGetPropGetter('integrationDetailsToEdit', {}),
  integrationDetails: createGetPropGetter('integrationDetails', {}),
  integrationOptionsList: createGetPropGetter('integrationOptionsList', []),
  integrations: createGetPropGetter('integrations', []),
  integrationsLoading: createGetPropGetter('integrationsLoading', false),
  integrationListOptions: createGetPropGetter('integrationListOptions', {}),
  integrationListSort(state, { integrationListOptions = {} }) {
    return integrationListOptions.sort || {};
  },
};
